import { ready, onShopifySectionLoad } from '../utils/readyinit';
import initCollectionHeader from '../sections/collection/initCollectionHeader';
import initCollectionSearchFilters from '../sections/collection/initCollectionSearchFilters';
import initCustomSortBy from '../sections/collection/initCustomSortBy';
import initAcsPaginationScroll from '../sections/collection/initAcsPaginationScroll';
import initCollectionRecs from '../sections/collection/initCollectionRecs';

window.theme = window.theme || {};
// Invoked BY GrapheneHC (configured dashboard-side as the collection response callback) —
// not called from theme code. Must keep existing, or the ACS loader calls undefined.
// The stash and event currently have no theme-side consumers (the load-more module that
// listened was removed on FB-358); kept as the stable hook for anything needing ACS
// response data without another dashboard config change.
window.theme.handleAcsCollectionResponse = (response) => {
  window.theme.acsCollectionResponse = response;
  document.dispatchEvent(new CustomEvent('acs:collection-loaded', { detail: response }));
};

ready(() => {
  initCollectionHeader();
  initCollectionSearchFilters();
  initCustomSortBy();
  initAcsPaginationScroll();
  initCollectionRecs();
});

onShopifySectionLoad(() => {
  initCollectionHeader();
  initCollectionSearchFilters();
  initCustomSortBy();
  initCollectionRecs();
});

const acsGridEl = document.querySelector('[data-acs-product-grid]');

if (acsGridEl) {
  // GrapheneHC injects the filters markup into [data-acs-product-grid] asynchronously,
  // after this script's initial init() pass has already bailed (no container yet), and
  // without changing the URL. Watch for the filters container appearing, and for ACS
  // re-injecting it on later facet/sort changes, and wire the filters once per node.
  // The observer fires on every descendant mutation (incl. product image swaps), so we
  // gate on the filters container identity before doing filter/sort setup work.
  let lastWiredContainerEl = null;
  let isAcsObserverQueued = false;

  const wireFiltersIfNeeded = () => {
    const containerEl = acsGridEl.querySelector('[data-filters-container]');
    if (!containerEl || containerEl === lastWiredContainerEl) return;
    lastWiredContainerEl = containerEl;
    initCollectionSearchFilters();
    initCustomSortBy();
    // ACS re-renders replace the card nodes, wiping Yotpo's rendered star widgets —
    // re-init here (the load-more module that previously refreshed them was removed
    // on FB-358 with the move to traditional pagination). initWidgets re-scans the
    // DOM, so repeat calls are idempotent. (Swym wishlist hearts self-recover; its
    // collections script observes injected content itself.)
    if (typeof window.yotpoWidgetsContainer?.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
    }
  };

  const handleAcsMutation = () => {
    wireFiltersIfNeeded();
  };

  const acsObserver = new MutationObserver(() => {
    if (isAcsObserverQueued) return;
    isAcsObserverQueued = true;
    requestAnimationFrame(() => {
      isAcsObserverQueued = false;
      handleAcsMutation();
    });
  });
  acsObserver.observe(acsGridEl, { childList: true, subtree: true });

  handleAcsMutation();
}
